"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
const LogoImage = _ref => {
  let {
    intl,
    url,
    affiliation
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    alt: intl.formatMessage(_messages.default.arialogo, {
      affiliation
    })
  });
};
var _default = exports.default = (0, _intl.injectIntl)(LogoImage);
LogoImage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LogoImage"
};